module.exports = __webpack_public_path__ + "img/Gamaliel.9cc7b318.jpg";